var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.blok)?_c('storyblok',{staticClass:"storyblok-richtext",attrs:{"blok":_vm.blok}},[_c('VRuntimeTemplate',{attrs:{"template":_vm.doc}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }